import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// 🔹 Firebase Configuration (Replace with your actual Firebase config)
const firebaseConfig = {
    apiKey: "AIzaSyB6AYr701f2kbDJeiwskAV9p20C3cQt8lM",
    authDomain: "sagarsamajapp-60802.firebaseapp.com",
    projectId: "sagarsamajapp-60802",
    storageBucket: "sagarsamajapp-60802.firebasestorage.app",
    messagingSenderId: "888593910429",
    appId: "1:888593910429:web:94756e73f46e1d98bde274",
    measurementId: "G-ZED76KPGL3"
};

// 🔹 Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// 🔹 Function to Request FCM Token
export const requestFCMToken = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            console.warn("🔕 Notifications permission denied.");
            return;
        }

        const token = await getToken(messaging, {
            vapidKey: "BB-33c8bIbNaCLcX7wgpvUsfLqCPS4Z85-ZKi4lXHgGo_IHlV-KW0LWbm6eH817XLeq3pNOOWKKW2p5BzVICgRU", // Generate from Firebase Console > Cloud Messaging
        });

        if (token) {
            console.log("✅ FCM Token:", token);
            return token;
        }
        console.log("⚠️ No FCM Token retrieved.");
    } catch (error) {
        console.error("❌ Error getting FCM token:", error);
    }
};

// 🔹 Listen for Foreground Notifications
onMessage(messaging, (payload) => {
    console.log("📩 Foreground Message Received:", payload);
});

export { messaging };
